import React from 'react';
import mermaid from 'mermaid';

const Roadmap = () => {
  const roadmap = `
    gantt
      dateFormat  YYYY-MM-DD
      title Roadmap
      section Section 1
        Q1 :task1, 2023-01-01, 30d
        Q2 :task2, 2023-04-01, 20d
        Q3 :task3, 2023-07-01, 15d
        Q4 :task4, 2023-10-01, 25d
  `;

  React.useEffect(() => {
    mermaid.initialize({ startOnLoad: true });
    mermaid.render('roadmapDiv', roadmap);
  }, []);

  return (
    <div id="roadmapDiv" className="roadmap"></div>
  );
};

export default Roadmap;